import React from 'react';
import { StyledTab, StyledTabList } from './SavedListingsTabs.styles';

type TabProps = {
    children: React.ReactElement | string;
    href: string;
    isSelected?: boolean;
    index?: number;
    testId?: string;
    _onSelectTab?: () => void;
};

export const Tab = ({
    children,
    isSelected,
    href,
    _onSelectTab,
    testId
}: TabProps) => {
    const tabRef = React.createRef<HTMLAnchorElement>();

    return (
        <StyledTab isSelected={isSelected}>
            <a
                onClick={(event) => {
                    event.preventDefault();
                    if (_onSelectTab) {
                        _onSelectTab();
                    }
                }}
                data-selected={isSelected}
                aria-selected={isSelected}
                ref={tabRef}
                href={href}
                data-testid={testId || ''}
            >
                {children}
            </a>
        </StyledTab>
    );
};

type TabsProps = {
    children: React.ReactElement | React.ReactElement[];
    selectedIndex?: number;
    onTabSelected?: (index: number) => void;
};

export const Tabs = ({ selectedIndex, onTabSelected, children }: TabsProps) => {
    const onSelectTab = (index: number) => {
        if (onTabSelected) {
            onTabSelected(index);
        }
    };

    return (
        <StyledTabList data-testid="tablist">
            {React.Children.map(children, (child, index) => {
                return React.cloneElement(
                    child as React.ReactElement<TabProps>,
                    {
                        index,
                        isSelected: selectedIndex === index,
                        _onSelectTab: () => onSelectTab(index)
                    }
                );
            })}
        </StyledTabList>
    );
};
